var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{attrs:{"show":_vm.dismissCountDown,"dismissible":"","variant":"success"},on:{"dismiss-count-down":_vm.countDownChanged,"dismissed":function($event){_vm.dismissCountDown=0}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'check']}}),_vm._v(" "+_vm._s(_vm.text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }